function initMustangLanding() {
  const section = document.querySelector('.mustang-landing');
  if (!section) return;

  console.log('Mustang landing loaded');

  // your JS here
}

// Page load
document.addEventListener('DOMContentLoaded', initMustangLanding);

// Shopify editor reload
document.addEventListener('shopify:section:load', initMustangLanding);